import { saveToIndexedDB, loadFromIndexedDB, removeFromIndexedDB, clearIndexedDB, migrateFromLocalStorage, initializeDefaultSettings } from './IndexedDBUtils';

// Fonction pour tenter de migrer les données de localStorage vers IndexedDB lors du chargement
// et initialiser les paramètres par défaut si nécessaire
(() => {
  // Exécuter la migration si nous sommes dans un environnement navigateur
  if (typeof window !== 'undefined') {
    migrateFromLocalStorage()
      .then(() => initializeDefaultSettings())
      .catch(error => console.error('Erreur lors de l\'initialisation:', error));
  }
})();

export const loadFromLocalStorage = async (key) => {
  try {
    let result;
    
    if (key === 'storedVerbatims' || key === 'notes' || key === 'slides') {
      result = await loadFromIndexedDB(key);
      // S'assurer que les collections sont toujours des tableaux
      if (!Array.isArray(result)) {
        console.warn(`loadFromLocalStorage: ${key} n'est pas un tableau, conversion en tableau vide`);
        return [];
      }
      return result;
    } else if (key === 'setupData') {
      return await loadFromIndexedDB(key);
    } else {
      return await loadFromIndexedDB('appSettings', key);
    }
  } catch (error) {
    console.error(`Erreur lors du chargement de ${key} depuis IndexedDB:`, error);
    // En cas d'erreur, retourner un tableau vide pour les collections
    if (['storedVerbatims', 'notes', 'slides'].includes(key)) {
      return [];
    }
    return null;
  }
};

export const saveToLocalStorage = async (key, data) => {
  try {
    // Vérifier et corriger les données avant de les enregistrer
    if ((key === 'storedVerbatims' || key === 'notes' || key === 'slides') && !Array.isArray(data)) {
      console.warn(`saveToLocalStorage: ${key} n'est pas un tableau, conversion en tableau vide`);
      data = [];
    }
    
    if (key === 'storedVerbatims' || key === 'notes' || key === 'slides' || key === 'setupData') {
      return await saveToIndexedDB(key, data);
    } else {
      return await saveToIndexedDB('appSettings', data, key);
    }
  } catch (error) {
    console.error(`Erreur lors de la sauvegarde de ${key} dans IndexedDB:`, error);
    // Afficher une alerte et sauvegarder comme fichier JSON en cas d'erreur
    alert(`Erreur de sauvegarde: ${error.message}. Saving data as a JSON file instead.`);
    
    // Code pour sauvegarder en JSON file
    const json = JSON.stringify(data);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${key}-backup.json`;
    a.click();
    URL.revokeObjectURL(url);
  }
};